import { lazy } from "react";
import AuthGuard from "../auth/AuthGuard";
import MatxLayout from "../components/MatxLayout/MatxLayout";
import { authRoles } from "../auth/authRoles";
import Loadable from "../components/Loadable";
import materialRoutes from "../views/material-kit/MaterialRoutes";
import RoomSharingUI from "app/views/presentation/RoomSharing/roomSharingUI";
import EventDashboard from "app/views/events/eventDashboard";

// Protected pages imports
const Dashboard = Loadable(lazy(() => import("../views/dashboard")));
const EventsList = Loadable(lazy(() => import("../views/pages/UpComingEvents/index.jsx")));
const ManageMembers = Loadable(lazy(() => import("../views/members")));
const MemberDetailPage = Loadable(lazy(() => import("../views/members/MemberDetails")));
const TransactionApprovalListPage = Loadable(lazy(() => import("../views/members/payments/tansactionApproval")));
const ReportsPage = Loadable(lazy(() => import("../views/events/reports/index")));
const SelfRegisterThroughUrl = Loadable(lazy(() => import("../views/events/registerThroughUrl")));
const RequestsListToChangePhoneNumber = Loadable(lazy(() => import("../views/changePhoneNumber/index")));
const ViewRequest = Loadable(lazy(() => import("../views/changePhoneNumber/viewRequest")));
const ContactSupport = Loadable(lazy(() => import("../views/footer/contactSupport/index")));
const Enrollments = Loadable(lazy(() => import("../views/pages/Enrollments/index.jsx")));
const MyEvents = Loadable(lazy(() => import("../views/pages/MyEvents/index.jsx")));
const MyOrders = Loadable(lazy(() => import("../views/events/MyOrders")));
const EventDetailPage = Loadable(lazy(() => import("../views/events/eventDetails")));
const MembersListByOrg = Loadable(lazy(() => import("../views/members/OrgMembers")));
const EventFormPage = Loadable(lazy(() => import("../views/events/eventForm")));
const EventRegistrationPayment = Loadable(lazy(() => import("../views/members/payments/makePayment")));
const BulkRegistrationPage = Loadable(lazy(() => import("../views/events/eventDetails/bulkRegistration/bulkRegistration")))
//EDIT POPUP to WEB PAGE
const EditTicketEventReportPage = Loadable(
  lazy(() => import("../views/events/reports/editReport/editTicketEventReport"))
);
const protectedRoutes = [
  {
    element: (
      <AuthGuard>
        <MatxLayout />
      </AuthGuard>
    ),
    children: [
      ...materialRoutes,
      { path: "/dashboard", element: <Dashboard />, auth: authRoles.admin },
      { path: "/events", element: <EventsList />, auth: authRoles.admin },
      { path: "/enrollments", element: <Enrollments /> },
      { path: "/my-events", element: <MyEvents /> },
      { path: "/my-orders", element: <MyOrders /> },
      { path: "/events/:id", element: <EventDetailPage />, auth: authRoles.admin },
      { path: "/members", element: <ManageMembers />, auth: authRoles.admin },
      { path: "/members/organisation-members", element: <MembersListByOrg /> },
      { path: "/members/:id", element: <MemberDetailPage />, auth: authRoles.admin },
      { path: "/events/create", element: <EventFormPage />, auth: authRoles.admin },
      { path: "/events/update", element: <EventFormPage />, auth: authRoles.admin },
      { path: "/events/bulk-registration", element: <BulkRegistrationPage />, auth: authRoles.admin },
      { path: "/events/review-payments/:id", element: <TransactionApprovalListPage />, auth: authRoles.admin },
      { path: "/events/reports/:id/:userName", element: <ReportsPage />, auth: authRoles.admin },
      { path: "/events/reports/:id", element: <ReportsPage />, auth: authRoles.admin },
      { path: "/payment/:event_id?/:user_id?", element: <EventRegistrationPayment /> },
      { path: "/events/:id", element: <SelfRegisterThroughUrl />, auth: authRoles.admin },
      { path: "/requests-list-to-change-phone-number", element: <RequestsListToChangePhoneNumber />, auth: authRoles.admin },
      { path: "/request-confirmation/:id/:requestId/:action", element: <ViewRequest />, auth: authRoles.admin },
      { path: "/contact-support", element: <ContactSupport />, auth: authRoles.admin },
      { path: "/event-dashboard/:event_code", element: <EventDashboard />, auth: authRoles.admin },
      {
        path: "/events/room-sharing/:event_code",
        element: <RoomSharingUI />,
        auth: authRoles.admin,
      },
      //edit popup to web page
      {
        path: "/events/reports/:id/:userName/update",
        element: <EditTicketEventReportPage />,
        auth: authRoles.admin,
      },
    ]
  }
];

export default protectedRoutes;
